// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.popup-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.4);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 1000;
}

.popup-content {
    background-color: white;
    border-radius: 12px;
    padding: 36px;
    width: 420px;
    max-width: 90%;
    box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);
    position: relative;
}

.popup-close {
    position: absolute;
    top: 20px;
    right: 20px;
    background: none;
    border: none;
    font-size: 24px;
    cursor: pointer;
    color: #777;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 32px;
    height: 32px;
    padding: 0;
}

.popup-close:hover {
    color: #333;
}

.popup-content h2 {
    margin: 0 0 32px;
    font-size: 28px;
    font-weight: 700;
    color: #111;
}

.social-button {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    padding: 12px;
    margin-bottom: 12px;
    border-radius: 8px;
    border: 1px solid rgb(228, 228, 231);
    background-color: white;
    font-size: 16px;
    font-weight: 500;
    cursor: pointer;
    transition: background-color 0.2s ease;
    position: relative;
    color: #333;
}

.social-button:hover {
    background-color: #f8f8f8;
}

.social-button .icon {
    position: absolute;
    left: 16px;
    display: flex;
    align-items: center;
    justify-content: center;
}

.x-icon {
    color: #000;
}

.github-icon {
    color: #333;
}

.divider {
    display: flex;
    align-items: center;
    text-align: center;
    margin: 28px 0;
}

.divider::before,
.divider::after {
    content: '';
    flex: 1;
    border-bottom: 1px solid #e4e4e7;
}

.divider span {
    padding: 0 16px;
    font-size: 12px;
    color: #71717a;
    font-weight: 500;
    letter-spacing: 0.05em;
}

.form-group {
    margin-bottom: 20px;
}

.form-group label {
    display: block;
    margin-bottom: 8px;
    font-size: 16px;
    font-weight: 500;
    color: #000;
}

.form-group input {
    width: 100%;
    padding: 12px 16px;
    border: 1px solid #e4e4e7;
    border-radius: 8px;
    font-size: 16px;
    transition: border-color 0.2s ease;
}

.form-group input::placeholder {
    color: #a1a1aa;
}

.form-group input:focus {
    outline: none;
    border-color: #2563eb;
    box-shadow: 0 0 0 1px rgba(37, 99, 235, 0.2);
}

.sign-in-button {
    width: 100%;
    padding: 14px;
    margin-top: 16px;
    background-color: #0f172a;
    color: white;
    border: none;
    border-radius: 8px;
    font-size: 16px;
    font-weight: 600;
    cursor: pointer;
    transition: background-color 0.2s ease;
}

.sign-in-button:hover {
    background-color: #1e293b;
}

.signup-link {
    margin-top: 24px;
    text-align: center;
    font-size: 15px;
    color: #4b5563;
}

.signup-link a {
    color: #2563eb;
    text-decoration: none;
    font-weight: 500;
}

.signup-link a:hover {
    text-decoration: underline;
}`, "",{"version":3,"sources":["webpack://./src/Popup.css"],"names":[],"mappings":"AAAA;IACI,eAAe;IACf,MAAM;IACN,OAAO;IACP,WAAW;IACX,YAAY;IACZ,oCAAoC;IACpC,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,aAAa;AACjB;;AAEA;IACI,uBAAuB;IACvB,mBAAmB;IACnB,aAAa;IACb,YAAY;IACZ,cAAc;IACd,0CAA0C;IAC1C,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,WAAW;IACX,gBAAgB;IAChB,YAAY;IACZ,eAAe;IACf,eAAe;IACf,WAAW;IACX,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,WAAW;IACX,YAAY;IACZ,UAAU;AACd;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,gBAAgB;IAChB,WAAW;AACf;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,WAAW;IACX,aAAa;IACb,mBAAmB;IACnB,kBAAkB;IAClB,oCAAoC;IACpC,uBAAuB;IACvB,eAAe;IACf,gBAAgB;IAChB,eAAe;IACf,sCAAsC;IACtC,kBAAkB;IAClB,WAAW;AACf;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,kBAAkB;IAClB,cAAc;AAClB;;AAEA;;IAEI,WAAW;IACX,OAAO;IACP,gCAAgC;AACpC;;AAEA;IACI,eAAe;IACf,eAAe;IACf,cAAc;IACd,gBAAgB;IAChB,sBAAsB;AAC1B;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,WAAW;AACf;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,yBAAyB;IACzB,kBAAkB;IAClB,eAAe;IACf,kCAAkC;AACtC;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,qBAAqB;IACrB,4CAA4C;AAChD;;AAEA;IACI,WAAW;IACX,aAAa;IACb,gBAAgB;IAChB,yBAAyB;IACzB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,eAAe;IACf,sCAAsC;AAC1C;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,gBAAgB;IAChB,kBAAkB;IAClB,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,qBAAqB;IACrB,gBAAgB;AACpB;;AAEA;IACI,0BAA0B;AAC9B","sourcesContent":[".popup-overlay {\n    position: fixed;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    background-color: rgba(0, 0, 0, 0.4);\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    z-index: 1000;\n}\n\n.popup-content {\n    background-color: white;\n    border-radius: 12px;\n    padding: 36px;\n    width: 420px;\n    max-width: 90%;\n    box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);\n    position: relative;\n}\n\n.popup-close {\n    position: absolute;\n    top: 20px;\n    right: 20px;\n    background: none;\n    border: none;\n    font-size: 24px;\n    cursor: pointer;\n    color: #777;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    width: 32px;\n    height: 32px;\n    padding: 0;\n}\n\n.popup-close:hover {\n    color: #333;\n}\n\n.popup-content h2 {\n    margin: 0 0 32px;\n    font-size: 28px;\n    font-weight: 700;\n    color: #111;\n}\n\n.social-button {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    width: 100%;\n    padding: 12px;\n    margin-bottom: 12px;\n    border-radius: 8px;\n    border: 1px solid rgb(228, 228, 231);\n    background-color: white;\n    font-size: 16px;\n    font-weight: 500;\n    cursor: pointer;\n    transition: background-color 0.2s ease;\n    position: relative;\n    color: #333;\n}\n\n.social-button:hover {\n    background-color: #f8f8f8;\n}\n\n.social-button .icon {\n    position: absolute;\n    left: 16px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}\n\n.x-icon {\n    color: #000;\n}\n\n.github-icon {\n    color: #333;\n}\n\n.divider {\n    display: flex;\n    align-items: center;\n    text-align: center;\n    margin: 28px 0;\n}\n\n.divider::before,\n.divider::after {\n    content: '';\n    flex: 1;\n    border-bottom: 1px solid #e4e4e7;\n}\n\n.divider span {\n    padding: 0 16px;\n    font-size: 12px;\n    color: #71717a;\n    font-weight: 500;\n    letter-spacing: 0.05em;\n}\n\n.form-group {\n    margin-bottom: 20px;\n}\n\n.form-group label {\n    display: block;\n    margin-bottom: 8px;\n    font-size: 16px;\n    font-weight: 500;\n    color: #000;\n}\n\n.form-group input {\n    width: 100%;\n    padding: 12px 16px;\n    border: 1px solid #e4e4e7;\n    border-radius: 8px;\n    font-size: 16px;\n    transition: border-color 0.2s ease;\n}\n\n.form-group input::placeholder {\n    color: #a1a1aa;\n}\n\n.form-group input:focus {\n    outline: none;\n    border-color: #2563eb;\n    box-shadow: 0 0 0 1px rgba(37, 99, 235, 0.2);\n}\n\n.sign-in-button {\n    width: 100%;\n    padding: 14px;\n    margin-top: 16px;\n    background-color: #0f172a;\n    color: white;\n    border: none;\n    border-radius: 8px;\n    font-size: 16px;\n    font-weight: 600;\n    cursor: pointer;\n    transition: background-color 0.2s ease;\n}\n\n.sign-in-button:hover {\n    background-color: #1e293b;\n}\n\n.signup-link {\n    margin-top: 24px;\n    text-align: center;\n    font-size: 15px;\n    color: #4b5563;\n}\n\n.signup-link a {\n    color: #2563eb;\n    text-decoration: none;\n    font-weight: 500;\n}\n\n.signup-link a:hover {\n    text-decoration: underline;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
